import React from 'react';
import { graphql } from 'gatsby';

import Layout from '~/components/Layout';
import Seo from '~/components/SEO';

import DynamicComponent from '~/components/DynamicComponent';
import TextCard from '~/components/Dynamic/TextCard';

import useStoryblok from '~/utils/storyblok-service';

import homePageHero from '~/images/homepage-hero.png';
import { useInView } from 'react-intersection-observer';

const IndexPage = ({ data, location, pageContext }) => {
  const story = useStoryblok(data.storyblokEntry, location);
  const content = story?.content;
  const components = content?.body?.filter(({component}) => component !== 'hero').map((blok) => <DynamicComponent blok={blok} key={blok._uid} />);

  const hero = content?.body?.filter(({component}) => component === 'hero').pop();

  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0
  });

  return (
    <Layout locale={pageContext.locale}>
      <Seo {...content.seo} lang={story.lang} pageContext={pageContext} />

      {hero && (
        <section className="mt-16 overflow-hidden">
          <div className="container">
            <div className="flex flex-wrap md:items-center md:flex-nowrap">
              <div style={{ flex: '1 1 600px' }} className="relative z-10 flex items-center justify-center">
                <TextCard blok={hero.textCard[0]} />
              </div>

              <div className="z-0 w-full -mt-16 -mb-8 md:w-1/2" ref={ref}>
                <div className="relative aspect-w-1 aspect-h-1">
                  {inView && (
                    <img src={homePageHero} className="absolute inset-0 transform scale-150 md:scale-125" alt="" />
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {components}
    </Layout>
  );
};

export default IndexPage;

export const query = graphql`
  query HomepageQuery($id: String!) {
    storyblokEntry(id: { eq: $id }) {
      id
      name
      content
      lang
      slug
      uuid
      full_slug
    }
  }
`;
